import { render } from "./Tt.vue?vue&type=template&id=5aec1d41"
import script from "./Tt.vue?vue&type=script&lang=js"
export * from "./Tt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__